export const floatCurrency = (value: any, defaultValue?: number, prefix: string = '$', suffix: string = '') => {
  const amount = isNaN(value) ? defaultValue : value || defaultValue
  if (amount === null || amount === undefined || isNaN(amount)) return '(NaN)'

  return `${prefix}${parseFloat(amount).toFixed(2)}${suffix}`
}
